import { useLocation, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
// import { string as toStyleString } from 'to-style'
import Cookies from 'universal-cookie/es6';
import axios from 'axios';
import rehypeRaw from 'rehype-raw'
import remarkGfm from "remark-gfm"
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { mystyle } from './SyntaxHighlightStyle'

export const cookiesManager = new Cookies();

var lid = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus quibusdam deserunt sit corporis quasi quo inventore libero praesentium autem incidunt, quos consectetur cumque, suscipit ipsum beatae quaerat expedita magnam? Rerum deleniti odio nobis cum ipsa numquam consequuntur impedit necessitatibus nulla saepe modi quidem maiores magnam vel, eligendi amet nemo nam, ex aspernatur labore non. Consectetur saepe est necessitatibus sint, accusamus placeat eveniet repudiandae aut distinctio impedit laboriosam iste autem nemo praesentium, sit, itaque fugit voluptates tenetur officia ipsa soluta! Error assumenda nam illum laborum consectetur cum harum, vitae aliquid tempore vel esse odio nostrum. Harum quae pariatur rem eveniet commodi illo, non error quidem amet totam odit, aut doloremque explicabo aspernatur eligendi magnam dignissimos eius alias excepturi nemo dolore ab minus provident tempora. Architecto cumque aspernatur ratione magni quasi mollitia repellat, assumenda asperiores voluptas dolore saepe libero corporis adipisci earum similique rerum velit eius repellendus, itaque quisquam quis officia nesciunt aut distinctio! Veniam, provident. Sint, expedita nostrum necessitatibus laborum maiores reiciendis laboriosam est possimus architecto minima ab, cum omnis repudiandae. Error, tempora. Exercitationem tempora, similique doloremque quia ipsa assumenda illo accusantium eos rem veniam odit, fugiat facere expedita repellat inventore dignissimos ducimus, nostrum ad? Totam rerum neque quam iste nemo at magnam aliquid voluptatem, veniam nesciunt, deleniti ipsam adipisci voluptates incidunt ullam repellat autem quo cum pariatur! Earum corrupti dolorum ipsa id, perferendis assumenda? Facere beatae dolores quia! Recusandae, at nemo explicabo odio minus laborum distinctio nostrum perspiciatis voluptas ullam vero praesentium, animi repellat ex ut quaerat nesciunt sapiente. Minus adipisci quidem officia eum! Eum corrupti voluptates laboriosam quibusdam sapiente quis consequatur voluptatem nemo tenetur modi, hic culpa commodi minima ipsum maiores dolores? Eos neque obcaecati sunt, nulla repellendus quas quia. Fugiat doloremque repellat dolorem pariatur expedita libero quas repudiandae corrupti consequatur ipsa. Debitis ipsum nemo repellendus non maxime quos possimus, excepturi ipsam aut et vel, officia aliquam iure quis laborum, reiciendis ratione illo consequuntur soluta iusto? Ipsam, eaque doloremque? Libero explicabo porro magni sint! Voluptate consequatur voluptatem amet nam omnis porro, repudiandae iste accusantium consectetur. Iusto labore dolore corrupti iste. Autem maxime ad beatae assumenda ducimus doloremque voluptates perferendis quia error, maiores voluptatum laboriosam porro ut veritatis quo aliquam, quidem, harum esse optio saepe praesentium consequatur illo dolorum culpa? Mollitia porro unde incidunt neque corporis repudiandae facere labore optio cumque accusamus deserunt voluptas qui ratione repellendus, id tempora repellat. Minima minus ad reprehenderit accusamus deleniti fugiat beatae consequatur voluptate delectus, est modi amet voluptas illo aspernatur illum reiciendis molestias necessitatibus, voluptates non eveniet iure, laborum asperiores. Et impedit assumenda dolor quam temporibus quod quis, eligendi qui doloremque quas a vero blanditiis libero rem labore mollitia natus necessitatibus unde commodi fugiat iusto ex. Impedit fugit delectus laboriosam qui ex distinctio minus blanditiis vel architecto nesciunt quo, ipsam animi asperiores adipisci eaque reiciendis non totam nemo a dolorem commodi. Vel assumenda inventore voluptatem est sapiente perspiciatis reprehenderit vero veniam doloremque ad repellat excepturi numquam deserunt maiores at labore eius magni autem, nihil dolore laborum? Accusantium amet ipsam tempora animi quo quibusdam."
var splited = lid.split(' ').filter(a => a);

export function lorem(integer) {
	return splited.slice(0, integer).reduce((a, b) => a + b + " ", "")
}

export function useGoto(link) {
	const navigate = useNavigate();
	return (useCallback(() => navigate(link, { replace: true }), [navigate, link]))
}

export function setCookies(obj) {
	// const cookies = new Cookies();
	for (var key in obj) {
		cookiesManager.set(key, obj[key], { path: "/", secure: true })
	}
	globalContextStore?.setLoggedIn(isLoggedIn())
}

export function getCookies() {
	return cookiesManager.getAll()
}

export function clearCookies() {
	for (var key in getCookies()) {
		// console.log({key})
		cookiesManager.remove(key)
	}
	globalContextStore.setLoggedIn(isLoggedIn())
}

export function isAdmin() {
	return isLoggedIn() && getCookies().role.toLowerCase() === "admin"
}

export function isLoggedIn() {
	// return true
	// console.log("ran isLoggedIn")
	var cook = getCookies()
	var ret = cook && cook.jwt && cook.loggedIn === "true"
	// console.log("result: " + ret, " cook: " + !(!cook), " cook.loggedIn: " + cook.loggedIn)
	return ret
}

export function getBearerToken(argjwt) {
	var jwt = argjwt !== undefined ? argjwt : getCookies().jwt
	if (!jwt)
		return jwt
	return "Bearer " + jwt
}

export function mouseEventStyles(mouseOverCssStyle, mouseDownCssStyle) {
	// var mouseDownCssStyleString = toStyleString(mouseDownCssStyle) 
	// var mouseOverCssStyleString = toStyleString(mouseOverCssStyle)
	// function handleMouseDown(e) {
	// 	var str = mouseDownCssStyleString
	// 	e.currentTarget.style.cssText = str;
	// }

	// function handleMouseUp(e) {
	// 	e.currentTarget.removeAttribute("style")
	// }

	// function handleMouseOver(e) {
	// 	var str = mouseOverCssStyleString
	// 	e.currentTarget.style.cssText = str;
	// }

	// var mouseEventProps = {
	// 	onMouseLeave: handleMouseUp,
	// 	onMouseUp: handleMouseUp
	// }
	// if (mouseOverCssStyleString) {
	// 	mouseEventProps.onMouseOver = handleMouseOver
	// }
	// if (mouseDownCssStyleString) {
	// 	mouseEventProps.onMouseDown = handleMouseDown
	// }
	// return mouseEventProps
}

export function useGetPath() {
	const location = useLocation()
	return location.pathname
}

export function getProfilePictureLink() {
	var link = getCookies().pfp
	if (!link) {
		return ""
	}
	return "https://api.pcbang.ma" + link
}

export function getUsername() {
	return getCookies().username
}

export function loggedOff(key, callback) {
	cookiesManager.addUniqueChangeListener(key, (e) => {
		if (e.name === "jwt" && e.value === undefined) {
			callback()
		}
	})
}

export function getPageOfTenBlogs(pageNumber, searchquery) {
	return axios.get("https://api.pcbang.ma/api/articles", {
		params:
		{
			populate: "image,author,author.avatar",
			"sort[0]": "id:desc",
			"pagination[pageSize]": "10",
			"pagination[page]": pageNumber ? pageNumber : "1",
			...(searchquery && {"filters[$or][0][content][$contains]": searchquery, "filters[$or][1][title][$contains]": searchquery })	
		}
	})
}

export const dynamicResourceLinks = (color, size) => {
	if (!color)
		color = "ffffff";
	if (!size)
		size = 30;
	return {
		logOutIcon: `https://img.icons8.com/ios-filled/${size}/${color}/logout-rounded.png`,
		userIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/user--v1.png`,
		trashCanIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/filled-trash.png`,
		editPenIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/edit--v1.png`,
		twitterIcon: `https://img.icons8.com/ios/${size}/${color}/twitter-circled--v1.png`,
		facebookIcon: `https://img.icons8.com/material-outlined/${size}/${color}/facebook-new.png`,
		globeIcon: `https://img.icons8.com/ios-filled/${size}/${color}/globe--v1.png`,
		instagramIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/instagram-circle.png`,
		gpsPinIcon: `https://img.icons8.com/ios-filled/${size}/${color}/marker.png`,
		saveIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/save--v1.png`,
		questionMarkIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/question-mark.png`,
		gameConsoleIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/controller.png`,
		arcadeIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/apple-arcade.png`,
		passwordKeyIcon: `https://img.icons8.com/material-rounded/${size}/${color}/password1.png`,
		openEyeIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/visible--v1.png`,
		closedEyeIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/invisible.png`,
		cancelIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/cancel.png`,
		updateIcon: `https://img.icons8.com/ios-filled/${size}/${color}/available-updates.png`,
		redoIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/redo.png`,
		undoIcon: `https://img.icons8.com/ios-glyphs/${size}/${color}/undo.png`
	}
}

export const resourceLinks = {
	"ff0059": {
		logOutIcon: "https://img.icons8.com/ios-filled/100/ff0059/logout-rounded.png",
		userIcon: "https://img.icons8.com/ios-glyphs/30/ff0059/user--v1.png",
		trashCanIcon: "https://img.icons8.com/ios-glyphs/30/ff0059/filled-trash.png",
		editPenIcon: "https://img.icons8.com/ios-glyphs/30/ff0059/edit--v1.png",
	},
	"ff0099": {
		facebookIcon: "https://img.icons8.com/material-outlined/100/ff0099/facebook-new.png",
		twitterIcon: "https://img.icons8.com/ios/100/ff0099/twitter-circled--v1.png",
		instagramIcon: "https://img.icons8.com/ios-glyphs/100/ff0099/instagram-circle.png",
	},
	"ff3366": {
		facebookIcon: "https://img.icons8.com/material-outlined/100/ff3366/facebook-new.png",
		globeIcon: "https://img.icons8.com/ios-filled/100/ff3366/globe--v1.png",
		instagramIcon: "https://img.icons8.com/ios-glyphs/100/ff3366/instagram-circle.png",
		gpsPinIcon: "https://img.icons8.com/ios-filled/100/ff3366/marker.png",
	},
	"ffffff": {
		saveIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/save--v1.png",
		questionMarkIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/question-mark.png",
		gameConsoleIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/controller.png",
		arcadeIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/apple-arcade.png",
		trashCanIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/filled-trash.png",
		editPenIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/edit--v1.png",
		passwordKeyIcon: "https://img.icons8.com/material-rounded/48/ffffff/password1.png",
		openEyeIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/visible--v1.png",
		closedEyeIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/invisible.png",
		cancelIcon: "https://img.icons8.com/ios-glyphs/30/ffffff/cancel.png",
		updateIcon: "https://img.icons8.com/ios-filled/30/ffffff/available-updates.png",
	},
	"ff09ff": {
		userIcon: "https://img.icons8.com/ios-glyphs/30/ff09ff/user--v1.png",
		logOutIcon: "https://img.icons8.com/ios-filled/100/ff09ff/logout-rounded.png",
		editPenIcon: "https://img.icons8.com/ios-glyphs/30/ff09ff/edit--v1.png",
		trashCanIcon: "https://img.icons8.com/ios-glyphs/30/ff09ff/filled-trash.png",
	}
}



export function deepcopy(obj) {
	return JSON.parse(JSON.stringify(obj))
}

export function timeit(msg, f, ...arr) {
	console.time(msg)
	f(...arr)
	console.timeEnd(msg)
}

export function Page(props) {
	return (
		<div className={"pagebody " + props.className}>
			<div className="mainbody">
				{
					props.children
				}
			</div>
		</div>
	)
}

export function jsonEscapeUTF(s) {
	return s.replace(/[^\x20-\x7F]/g, x => "\\\\u" + ("000" + x.codePointAt(0).toString(16)).slice(-4))
}

export function jsonParseUTF(s) {
	return s.replace(/\\u[0-9a-f][0-9a-f][0-9a-f][0-9a-f]/g, x => JSON.parse(`"${x}"`))
}

export function isEmptyOrSpaces(str) {
	return str === null || str.match(/^ *$/) !== null;
}

export function capitalize(phrase) {
	return phrase
		.split(' ').map(word => word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}


export function ShowConditonally({ cond, children }) {
	// console.log({children})
	if (children) {
		if (children.length) {
			if (children.length > 0 && cond) {
				return children[0];
			}
			else if (children.length > 1 && !cond) {
				return children[1]
			}
		}
		else if (cond) {
			return children
		}
	}
	return <></>
}

export const stateObject = (arr) => ({ get: () => arr[0], set: () => arr[1] })

export const bestFittingImage = (formats, defaultFormat, desiredDims, fallback) => {
	var chosenFormat = null;
	if (formats) {
		formats["default"] = { url: defaultFormat.url, width: defaultFormat.width, height: defaultFormat.height }
		// console.log({formats})
		for (var key in formats) {
			if (!chosenFormat ||
					(
						formats[key].width &&
						(Math.abs(formats[key].width - desiredDims.width) < Math.abs(chosenFormat.width - desiredDims.width)) &&
						(formats[key].width >= desiredDims.width || chosenFormat.width < desiredDims.width)
					)
				) {
				chosenFormat = formats[key];
				chosenFormat.name = key;
			}
		}
	}
	// console.log("chosen format for width:", desiredDims.width, "is", chosenFormat, "\nformats:", formats)
	return chosenFormat ? "https://api.pcbang.ma" + chosenFormat.url : (fallback ? fallback : `https://via.placeholder.com/${desiredDims.width}x${desiredDims.height}`);
}


export const globalUnifiedOptions = {
	remarkPlugins: [remarkGfm],
	rehypePlugins: [rehypeRaw],
	components: {
		code({ node, inline, className, children, ...props }) {
			// console.trace()
			const match = /language-(\w+)/.exec(className || '')
			if ((!inline && match) === false) {
				return <code className={className} {...props}>
					{children}
				</code>
			}
			return !inline && match ?
				(
					<SyntaxHighlighter children={String(children).replace(/\n$/, '')} PreTag="pre" language={match[1]} style={mystyle} {...props} />
				)
				: (<pre><code className={className} {...props}>
					{children}
				</code></pre>)
		},
		"align-left": ({ node, inline, className, children, ...props }) => {
			return (
				<div className={"flex-column flex-ai-fs align-text-left " + className}>
					{children}
				</div>
			)
		},
		"align-right": ({ node, inline, className, children, ...props }) => {
			return (
				<div className={"flex-column flex-ai-fe align-text-right " + className}>
					{children}
				</div>
			)
		},
		"align-center": ({ node, inline, className, children, ...props }) => {
			return (
				<div className={"flex-column flex-ai-cr align-text-center " + className}>
					{children}
				</div>
			)
		},
	}
}

export var globalContextStore;
export function setGlobalContextStore(val) {
	globalContextStore = val;
	return val;
}